/**
 * Keep --app-height in sync with the *visible* viewport.
 *
 * `100vh` on mobile/tablet browsers (especially Chrome/Android in desktop-site
 * mode) is the large viewport: it includes the URL bar and the Android taskbar,
 * so the bottom of the UI — chat composer, action bars — sits off-screen.
 *
 * visualViewport.height is the reliable value. CSS falls back to 100dvh
 * (then 100vh) until this script runs.
 */
export function initViewportHeight() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  const root = document.documentElement;

  const setAppHeight = () => {
    const vv = window.visualViewport;
    const height = Math.round((vv && vv.height) || window.innerHeight);
    if (!height) return;
    root.style.setProperty("--app-height", `${height}px`);
    root.style.height = `${height}px`;
  };

  setAppHeight();

  window.addEventListener("resize", setAppHeight);
  window.addEventListener("orientationchange", () => {
    setAppHeight();
    // iOS/Android often report the previous size until rotation settles.
    window.setTimeout(setAppHeight, 100);
    window.setTimeout(setAppHeight, 400);
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", setAppHeight);
    window.visualViewport.addEventListener("scroll", setAppHeight);
  }
}
